import { render } from "./SearchSeller.vue?vue&type=template&id=a301fb76"
import script from "./SearchSeller.vue?vue&type=script&lang=js"
export * from "./SearchSeller.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__